import { z } from '@harvestiq/zod';

import { campaignResponseSchema } from './campaign-schema';

export const getCampaignByIdParamsSchema = z.object({
  campaignId: z.string().uuid(),
});
export type GetCampaignByIdParams = z.infer<typeof getCampaignByIdParamsSchema>;

export const getCampaignByIdResponseSchema = z.object({
  campaign: campaignResponseSchema.nullable(),
});
export type GetCampaignByIdResponse = z.infer<
  typeof getCampaignByIdResponseSchema
>;
